// extracted by mini-css-extract-plugin
module.exports = {"Container":"RecipeCreateEditForm_Container__Vd_a2"};